import React, { useEffect, useState } from 'react'
import TitleCard from '../components/TitleCard'
import OrderListItem from '../components/OrderListItem'
import FiltersAddBarOrders from '../components/FiltersAddBarOrders'
import moment from 'moment'

const PAGE_LIMIT = 100

function Orders(props) {
  const [search, setSearch] = useState('')
  const [filterParams, setFilterParams] = useState({
    filter: 'now',
    end: new Date(),
    start: getFirstDayOfThisMonth(),
    showCancelled: 'active',
  })
  const [page, setPage] = useState(1)
  const [orders, setOrders] = useState([])
  const [total, setTotal] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [reloadCounter, setReloadCounter] = useState(0)

  // Reset to page 1 when filters change.
  useEffect(() => {
    setPage(1)
  }, [
    filterParams.filter,
    filterParams.start,
    filterParams.end,
    filterParams.showCancelled,
  ])

  useEffect(() => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('x-auth-token', localStorage.getItem('cut-catering-token'))

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    }

    fetch(
      'https://app.cutcatering.it/api/orders/?' +
        new URLSearchParams({
          filter: filterParams.filter,
          end: filterParams.end.getTime(),
          start: filterParams.start.getTime(),
          showCancelled: filterParams.showCancelled || 'active',
          page,
          limit: PAGE_LIMIT,
        }),
      requestOptions,
    )
      .then(response => response.json())
      .then(result => {
        setOrders(result.orders || [])
        setTotal(result.total || 0)
        setHasMore(!!result.hasMore)
      })
      .catch(error => console.log('error', error))
  }, [filterParams, page, reloadCounter])

  const filterOptions = [
    { label: 'Oggi', value: 'now' },
    { label: 'Domani', value: 'tomorrow' },
    { label: 'Range', value: 'range' },
    { label: 'Tutti', value: 'all' },
  ]
  const showCancelledOptions = [
    { label: 'Attivi', value: 'active' },
    { label: 'Cancellati', value: 'cancelled' },
    { label: 'Tutti', value: 'all' },
  ]

  let getOrders = function () {
    return orders.filter(e => {
      if (!search) return true
      if (e.customer?.toLowerCase().includes(search.toLowerCase())) return true
      if (e.name?.toLowerCase().includes(search.toLowerCase())) return true
      return false
    })
  }

  let getOrdersArray = function () {
    let rows = getOrders().map(e => [
      e.customer,
      e.name,
      e.type,
      getPeople(e.items),
      e.account || 'guest',
      formatDate(e.time),
      e.deletedAt ? 'cancellato' : 'attivo',
    ])
    let customers = {}
    let days = {}

    rows.forEach(([customerD, , , peopleD, , dateD]) => {
      if (!customers[customerD])
        customers[customerD] = { name: customerD, all: 0 }
      if (!customers[customerD][dateD]) customers[customerD][dateD] = 0
      customers[customerD][dateD] += peopleD
      customers[customerD].all += peopleD
      days[dateD] = dateD
    })

    let rowsByDay = []
    let rowsByMonth = []

    Object.values(customers).forEach(cm => {
      let counter = 0
      Object.values(days).forEach(day => {
        counter += cm[day]
        rowsByDay.push([cm.name, '', '', cm[day], '', days[day]])
      })

      rowsByMonth.push([cm.name, '', '', counter, '', ''])
    })

    const head1 = [
      'cliente',
      'nome',
      'tipo',
      'persone',
      'account',
      'data',
      'stato',
    ]
    const empty = ['', '', '', '', '', '', '']

    return [
      head1,
      ...rows,
      empty,
      empty,
      empty,
      ...rowsByDay,
      empty,
      empty,
      empty,
      ...rowsByMonth,
    ]
  }

  let downloadBtn = function () {
    let csvContent =
      'data:text/csv;charset=utf-8,' +
      getOrdersArray()
        .map(e => e.join(';'))
        .join('\n')

    var encodedUri = encodeURI(csvContent)
    var link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'cut-catering-export.csv')
    document.body.appendChild(link)

    link.click()
  }

  const filteredOrders = getOrders()
  const totalPages = Math.max(1, Math.ceil(total / PAGE_LIMIT))

  return (
    <div className="dashboard-container">
      <div className="column">
        <TitleCard title="Ordini" subtitle={`Tutti gli ordini ricevuti!`} />
      </div>
      <div className="column">
        <FiltersAddBarOrders
          search={search}
          setSearch={setSearch}
          newPath="/customers/new"
          downloadBtn={downloadBtn}
          filterOptions={filterOptions}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          showCancelledOptions={showCancelledOptions}
        />
      </div>
      <div className="column-wrap">
        <div className="column-100 column-child-lg-50 orders-list">
          {filteredOrders.map((el, key) => (
            <div key={key} className="col-element">
              <OrderListItem
                order={el}
                onChanged={() => setReloadCounter(c => c + 1)}
              />
            </div>
          ))}
        </div>
      </div>
      {total > PAGE_LIMIT && (
        <div className="pagination-footer">
          <button
            type="button"
            className="pagination-btn"
            disabled={page <= 1}
            onClick={() => setPage(p => Math.max(1, p - 1))}
          >
            ← Precedente
          </button>
          <span>
            Pagina {page} di {totalPages} — {total} ordini
          </span>
          <button
            type="button"
            className="pagination-btn"
            disabled={!hasMore}
            onClick={() => setPage(p => p + 1)}
          >
            Successiva →
          </button>
        </div>
      )}
    </div>
  )
}

function getPeople(items) {
  let categories = {}
  items?.forEach(element => {
    if (!categories[element.categoryId]) categories[element.categoryId] = 0
    categories[element.categoryId] += element.quantity
  })
  return Math.max(...Object.values(categories)) || 0
}

function formatDate(time) {
  const date = new Date(time)
  return moment(date).format('YYYY-MM-DD')
}

function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1)
}

function getFirstDayOfThisMonth() {
  const date = new Date()
  return getFirstDayOfMonth(date.getFullYear(), date.getMonth())
}

export default Orders
